import React, { useEffect, useState } from "react";
import Breadcrums from "../../../components/breadcrums";
import { timesheetBreadcrums } from "../../../constants/breadcrums";
import { sectionClass, timesheetCommands } from "../../../constants/common";
import PageTitle from "../../../components/pageTitle";
import { listOfEmployees } from "../../../api/consultants-api";
import classNames from "classnames";
import CommonFilters from "../../../blocks/commonFilters";
import { timesheetWeeklyDetails } from "../../../api/timesheet-api";
import { TimesheetType } from "../../../model";
import { ColumnDef } from "@tanstack/react-table";
import TanstackTable from "../../../components/TanstackTable";

export default function TimesheetWeeklyResourcewise() {
    const [isLoading, setLoading] = React.useState(false);
    const [people, setPeople] = useState<any[]>([]);
    const [data, setData] = React.useState<TimesheetType[]>([]);

    const columns = React.useMemo<ColumnDef<TimesheetType, any>[]>(
        () => [
            {
                accessorKey: "name",
                header: "Name",
                cell: (info) => info.getValue(),
                enableColumnFilter: false,
                enableGrouping: false,
                footer: ({ table }) => (
                    <span className="font-semibold text-md">Total</span>
                ),
            },
            {
                accessorKey: "week",
                header: "Week",
                cell: (info) => info.getValue(),
                enableColumnFilter: false,
                enableGrouping: false,
                meta: {},
            },
            // {
            //     accessorKey: "month",
            //     header: "Month",
            //     cell: (info) => info.getValue(),
            //     enableColumnFilter: false,
            //     enableGrouping: false,
            //     meta: {},
            // },
            {
                accessorKey: "week_start",
                header: "Period Start",
                cell: (info) => info.getValue(),
                enableColumnFilter: false,
                enableGrouping: false,
                meta: {},
            },
            {
                accessorKey: "week_end",
                header: "Period End",
                cell: (info) => info.getValue(),
                enableColumnFilter: false,
                enableGrouping: false,
                meta: {},
            },
            {
                accessorKey: "totalHrs",
                header: "Efforts (Hrs)",
                cell: (info) => Number(info.getValue()) || 0,
                enableGrouping: false,
                enableColumnFilter: false,
                meta: {
                    cellClassName: "text-right",
                },
                footer: ({ table }) => (
                    <span className="text-md">
                        {table
                            .getFilteredRowModel()
                            .rows.reduce((total, row) => total + (row.original.totalHrs || 0), 0)
                            .toLocaleString()}
                    </span>
                ),
            },
        ],
        []
    );

    useEffect(() => {
        setLoading(true);
        listOfEmployees()
            .then((data) => setPeople(data))
            .finally(() => setLoading(false));
    }, []);

    function applyFilters(filters: any): void {
        setLoading(true);
        setData([]);
        timesheetWeeklyDetails(filters)
            .then((data) => setData(data))
            .finally(() => setLoading(false));
    }

    return (
        <div>
            <main>
                <Breadcrums breadcrumLinks={timesheetBreadcrums} commands={timesheetCommands} module={"Timesheet"} groups={["Statement"]} />
                <PageTitle title={"Resourcewise Weekly Timesheet Statement"} preSummary={"Organizational Overview"} summary={"Overview of monthly total of individual employee."} />
                <div className={classNames(sectionClass)}>
                    <CommonFilters people={people} applyFilters={applyFilters} clientId={null} />
                    {data && data.length > 0 && (
                        <TanstackTable columns={columns} data={data} downloadBtn={true} />
                    )}
                </div>
            </main>
        </div>
    );
}
